import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  NavLink,
  Label,
  FormGroup,
} from "reactstrap";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

import * as actions from "../../../store/actions/index";

// core components
import LandingPageNavbar from "../../../Components/Navbars/LandingPageNavbar";
import TransparentFooter from "../../../Components/Footers/DarkFooter";

const SignUpPage = (props) => {
  const [firstFocus, setFirstFocus] = useState(false);
  const [lastFocus, setLastFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [idNumberFocus, setIdNumberFocus] = useState(false);
  const [cellNumberFocus, setCellNumberFocus] = useState(false);
  const [passwordFocus, setpasswordFocus] = useState(false);
  const [alert, setAlert] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [gender, setGender] = useState("");
  const [cellNumber, setCellNumber] = useState("");

  const hideAlert = () => {
    setAlert(null);
    props.onAuthFailClear();
  };

  const errorAlert = (props, show) => {
    setAlert(
      <SweetAlert
        danger
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="An error has occured!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        show={show}
      >
        {props.error}
      </SweetAlert>
    );
  };

  useEffect(() => {
    errorAlert(props, props.error !== null);
  }, [props]);

  return (
    <>
      <LandingPageNavbar />

      <div
        className="section section-signup page-header-image"
        style={{
          backgroundImage:
            "url(" +
            require("../../../assets/img/pexels-pixabay-34514.jpg").default +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          minHeight: "700px",
        }}
      >
        <Container>
          <Row>
            {alert}
            <Card className="card-signup" data-background-color="orange">
              <Form
                id="sign-up-form"
                role="form"
                onSubmit={(event) => {
                  event.preventDefault();
                  props.onRegister(
                    firstName,
                    lastName,
                    idNumber,
                    emailAddress,
                    password,
                    gender,
                    cellNumber
                  );
                }}
              >
                <CardHeader className="text-center">
                  <CardTitle className="title-up" tag="h8">
                    Sign Up
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <InputGroup
                    className={
                      "no-border" + (firstFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="First Name"
                      type="text"
                      required
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                      onChange={(event) => setFirstName(event.target.value)}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (lastFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons text_caps-small"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Last Name"
                      type="text"
                      required
                      onFocus={() => setLastFocus(true)}
                      onBlur={() => setLastFocus(false)}
                      onChange={(event) => setLastName(event.target.value)}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (emailFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email"
                      type="text"
                      required
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}
                      onChange={(event) => setEmailAddress(event.target.value)}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border input-lg" +
                      (idNumberFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons business_badge"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="ID Number"
                      type="text"
                      required
                      onFocus={() => setIdNumberFocus(true)}
                      onBlur={() => setIdNumberFocus(false)}
                      onChange={(event) => setIdNumber(event.target.value)}
                    ></Input>
                  </InputGroup>

                  <InputGroup
                    className={
                      "no-border input-lg" +
                      (cellNumberFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons tech_mobile"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Cell Number"
                      type="text"
                      required
                      onFocus={() => setCellNumberFocus(true)}
                      onBlur={() => setCellNumberFocus(false)}
                      onChange={(event) => setCellNumber(event.target.value)}
                    ></Input>
                  </InputGroup>

                  <FormGroup
                    check
                    className="form-check-radio"
                    inline
                    onChange={(event) => setGender(event.target.value)}
                  >
                    <Label check>
                      <Input
                        defaultValue="Male"
                        id="inlineRadio1"
                        name="inlineRadioOptions"
                        type="radio"
                        required
                      ></Input>
                      Male <span className="form-check-sign"></span>
                    </Label>
                  </FormGroup>
                  <FormGroup
                    check
                    className="form-check-radio"
                    inline
                    onChange={(event) => setGender(event.target.value)}
                  >
                    <Label check>
                      <Input
                        defaultValue="Female"
                        id="inlineRadio2"
                        name="inlineRadioOptions"
                        type="radio"
                        required
                      ></Input>
                      Female <span className="form-check-sign"></span>
                    </Label>
                  </FormGroup>

                  <InputGroup
                    className={
                      "no-border input-lg" +
                      (passwordFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="now-ui-icons objects_key-25"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type="password"
                      required
                      onFocus={() => setpasswordFocus(true)}
                      onBlur={() => setpasswordFocus(false)}
                      onChange={(event) => setPassword(event.target.value)}
                    ></Input>
                  </InputGroup>
                </CardBody>
                <CardFooter className="text-center">
                  <Button
                    className="btn-neutral btn-round"
                    color="info"
                    type="submit"
                    size="lg"
                  >
                    Get Started
                  </Button>
                  <div>
                    <h6>
                      <NavLink to="/Login" tag={Link} className="link">
                        Already have an account?
                      </NavLink>
                    </h6>
                  </div>
                </CardFooter>
              </Form>
            </Card>
          </Row>
        </Container>
      </div>
      <TransparentFooter />
      {/* </div> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    error: state.authentication.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRegister: (
      firstName,
      lastName,
      idNumber,
      emailAddress,
      password,
      gender,
      cellNumber
    ) =>
      dispatch(
        actions.register(
          firstName,
          lastName,
          idNumber,
          emailAddress,
          password,
          gender,
          cellNumber
        )
      ),
    onAuthFailClear: () => dispatch(actions.authFailClear()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);
